import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllHotelsSummary, setSelection, setView } from "../../../../../Redux/slice/features/hotelOccupancySlice";

const AllHotelsMonthlyOccTable = () => {
  const dispatch = useDispatch();
  const { allHotelsSummary, year } = useSelector((state) => state.hotelOcc);
  

  useEffect(() => {
    dispatch(fetchAllHotelsSummary(year));
  }, [dispatch,  year]);

  const handleClick = (monthName) => {
    const monthMap = {
      January: 1, February: 2, March: 3, April: 4, May: 5, June: 6,
      July: 7, August: 8, September: 9, October: 10, November: 11, December: 12
    };

    dispatch(setSelection({ hotelId: 0, year, month: monthMap[monthName] }));
    dispatch(setView("detail"));
  };


  return (
    <>
      
      <table className="table">
        <thead>
          <tr>
            <th>SL #</th>
            <th>Month</th>
            <th>Total Occupancy</th>
          </tr>
        </thead>
        <tbody>
          {allHotelsSummary.map((row, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{row.Month}</td>
              <td>
                <button onClick={() => handleClick(row.Month)}>
                  {row.TotalOccupancy}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default AllHotelsMonthlyOccTable;
